import React from 'react';
import { motion } from 'framer-motion';

/** Wrap each routed page so route changes cross-fade with a soft rise. */
const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 18, filter: 'blur(6px)' }}
    animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
    exit={{ opacity: 0, y: -12, filter: 'blur(6px)' }}
    transition={{ duration: 0.45, ease: [0.2, 0.8, 0.2, 1] }}
    style={{ width: '100%' }}
  >
    {children}
  </motion.div>
);

export default PageTransition;
